import { SettingsAttributes } from 'core_main/api/settings/types';
import { InitCallbackResponse } from './types';

export const createInitCallbackResponse = (
  settings: SettingsAttributes,
): InitCallbackResponse => {
  const {
    embedIconUrl,
    embedIconColor,
    teamIconUrl,
    teamName,
    waitMessage,
    greeting,
    singleSessionChat,
    noHistory,
    offhoursImageUrl,
    offhoursMessage,
    closableChat,
    widgetType,
    activeAssistant,
    volumeControl,
    domainCriteria,
    colors,
    showBrandingIdentifier,
    brandId,
    knowledgeBaseId,
  } = settings;

  const { customWaitMessage } = volumeControl;

  return {
    settings: {
      embedIconUrl,
      embedIconColor,
      teamName,
      teamIconUrl,
      waitMessage: customWaitMessage || waitMessage,
      greeting,
      singleSessionChat,
      noHistory,
      offhoursImageUrl,
      offhoursMessage,
      closableChat,
      widgetType,
      activeAssistant,
      volumeControl,
      domainCriteria,
      colors,
      showBrandingIdentifier,
      brandId,
      knowledgeBaseId,
    },
  };
};
